<template>
  <!-- Не вешать OS на .popup: OverlayScrollbars ломает flex + fixed и прячет модалки (ОС и др.) на малых экранах. Скролл у .popup нативный. -->
  <div v-os-scrollbar="{ selectors: ['.faq-block', '.account-receipts-list', '.account-game-result__list', '.prizes-list', '.winners-list', '.dropdown__list', '.dropdown__list-scroll'] }"
       v-ios-scrollbar="{ selectors: ['.faq-block', '.account-receipts-list', '.account-game-result__list', '.prizes-list', '.winners-list', '.dropdown__list', '.dropdown__list-scroll'] }">
    <router-view></router-view>
    
    <!-- Cookie-баннер -->
    <CookieBanner />

    <SiteFooter
      :rules-url="rulesUrl"
      :policy-url="policyUrl"
      @rules-click="handleRulesButtonClick()"
      @open-question="openQuestionPopup()"
    />

    <AppShellPopups />

  </div>
</template>

<script>
/* global ym */
/* global _txq */
/* global qrWidget */
import { state } from "@/store";
import { feedbackIdentityPrefill } from '@/utils/feedbackFormPrefill';
import {
  formatRussianMobileE164,
  isValidRussianMobilePhone,
  russianMobilePhoneHint,
} from '@/utils/russianMobilePhone';
import { registerNameSignificantLength } from '@/utils/registerPersonName';
import {
  fetchFAQ,
  getToken,
  getUserInfo,
  removeToken,
  authorize,
  register,
  getMainSettings,
  sendFeedback,
  formatFeedbackSendError,
  formatApiErrorResponseMessage,
  setAuthHeader,
  sendResetPassword,
  fetchTopics,
  getUserChecks, getFeedbackTopics,
  APMCHECK_API_KEY,
  APMCHECK_API_URL,
} from './api';
import adRiver from '@/services/adriver';
import metrikaMixin from "@/mixins/metrikaMixin";
import { initMetrikaAutoGoals, YANDEX_METRIKA_COUNTER_ID } from "@/utils/metrika";
import { ANALYTICS_DISABLED } from '@/config/analytics';
import {useGlobalSetup} from "@/composables/useGlobalSetup";
// import { sendAdRiverMetrik } from '@/utils/metrika';
import CookieBanner from '@/components/CookieBanner.vue';
import SiteFooter from '@/components/layout/SiteFooter.vue';
import AppShellPopups from '@/components/layout/AppShellPopups.vue';
import { appRootKey } from '@/injectionKeys';
import { hasCookieConsent } from '@/utils/cookieConsent';
import { tryCloseApmModalOnBackdropClick } from '@/utils/apmUploadModalBackdrop';

export default {
  name: 'App',
  mixins: [metrikaMixin],
  components: {
    CookieBanner,
    SiteFooter,
    AppShellPopups,
  },
  provide() {
    return {
      [appRootKey]: this,
    };
  },
  setup() {
    useGlobalSetup();
    return {
      state,
    };
  },
  data() {
    return {
      formSending: false,
      resetPasswordEmail: null,
      isOpen: false,
      selectedText: 'Тема обращения',
      topics: [],
      scrollPercentages: [25, 50, 75, 100],
      hasReached: {
        scroll_to_footer: false,
        scroll_page_25: false,
        scroll_page_50: false,
        scroll_page_75: false,
        scroll_page_100: false,
        timer_15_seconds: false,
        timer_60_seconds: false,
      },
      timerStarted: false,
      checkInterval: null,
      checksTotal: 0,
      checkSoon: false,
      utmParams: {},
      clientId: null,
      isHeaderScrolled: false,
      scrollThreshold: 0,
      rootUrl: window.location.origin,
      userId: '',
      userUuid: '',
      isMobileNavOpened: false,
      faq: [],
      prizes: [],
      user: null,
      showLoginPopup: false,
      showCommonLoginPopup: false,
      showRegisterPopup: false,
      showRegisterPopupSuccess: false,
      showQuestionPopup: false,
      showQuestionPopupSuccess: false,
      showResetPasswordPopup: false,
      showResetPasswordSuccess: false,
      showPromoNotStarted: false,
      showPromoEnd: false,
      showSpecialPrizeEnding: false,
      specialPrizePopupTimer: null,
      AccountPopup: false,
      questionForm: {
        name: this.user && this.user.first_name ? this.user.first_name : '',
        email: this.user && this.user.email ? this.user.email : '',
        text: '',
        agree_personal_data: false,
        agree_to_advertising: false,
        subject: '',
        files: []
      },
      options: [],
      filePreviews: [],
      phone_number: '',
      email: '',
      password: '',
      passwordVisible: false,
      registerForm: {
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        is_policy: false,
        agree_rules: false,
        agree_to_advertising: false
      },
      registerPhoneTouched: false,
      loginForm: {
        phone_number: '',
        password: '',
      },
      loginFormErrors: {},
      resetPasswordForm: {
        email: '',
      },
      checks: {
        count: 0,
        next: null,
        previous: null,
        results: [],
      },
      checkOffset: 0,
      checkLimit: 18,
      feedbackErrors: {},
      resetPasswordErrors: {},
      errors: {},
      responseError: '',
      registrationSuccessEmail: '',
      days: 0,
      hours: 0,
      minutes: 0,
      timerMessage: '',
      mainSettings: {},
      sections: [
        { name: 'Покупайте товары', component: 'PurchaseSection', scrolled: false },
        { name: 'Регистрируйте чеки', component: 'RegisterSection', scrolled: false},
        { name: 'Участвуйте в викторине', component: 'QuizSection', scrolled: false },
        { name: 'Выигрывайте призы', component: 'PrizeSection', scrolled: false }
      ],
      activeSectionAccount: 0,
      scrolledSection: -1
    };
  },
  async created() {
    try {
      this.mainSettings = await getMainSettings();
      this.scheduleSpecialPrizeEndingPopup();
    } catch (error) {
      console.error('Failed to fetch main settings', error);
    }
    this.loadFAQ();
    this.checkAuthentication();
    this.fetchTimerData();
  },
  async mounted() {
    // adRiver.trackPageView();
    // sendAdRiverMetrik("all-pages");
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get("ref");
    if (ref) {
      state.ref = ref;
    }
    await this.fetchTopics();
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
    this.initScrollAnimations();
    this.getClientId();
    initMetrikaAutoGoals();
    this.getUTMParams();
    this.applyPerformanceMode();
    window.addEventListener('resize', this.applyPerformanceMode, { passive: true });
    // this.fetchUsersCheck();
    document.addEventListener('click', this.handleDynamicButtonClick);
    this.fetchOptions();
    document.documentElement.style.setProperty('--text-accent-1-1', 'var(--desired-color)');
    window.addEventListener('colorChange', (event) => {
      this.color = event.detail;
    });
    setAuthHeader();
    const token = getToken();
    if (token) {
      getUserInfo().then(userInfo => {
        if (userInfo) {
          this.userId = userInfo.id;
          this.userUuid = userInfo.uuid;
          this.user = {
            first_name: userInfo.first_name,
            last_name_initial: (userInfo.last_name || '').charAt(0),
            email: userInfo.email,
          };
          this.questionForm.name = userInfo.first_name;
          this.questionForm.email = userInfo.email;
          this.initQrWidget();
        }
      }).catch(error => {
        console.error('Failed to fetch user info on mount', error);
      });
    }
    this.initFloatingLabels();
  },
  updated() {
    this.$nextTick(() => {
      this.initFloatingLabels();
    });
  },
  unmounted() {
    window.removeEventListener('resize', this.applyPerformanceMode);
    if (this._handleScrollRafId) {
      cancelAnimationFrame(this._handleScrollRafId);
      this._handleScrollRafId = null;
    }
    if (this.specialPrizePopupTimer) {
      clearTimeout(this.specialPrizePopupTimer);
      this.specialPrizePopupTimer = null;
    }
    document.body.classList.remove('is-upload-widget-opened');
  },
  watch: {
    '$route.path'(newPath) {
      if (newPath === '/') {
        this.scheduleSpecialPrizeEndingPopup();
      }
    }
  },
  computed: {
    isTelegramPage() {
      return this.$route?.meta?.isTelegramPage === true;
    },
    rulesUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/rules`;
    },
    policyUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/policy`;
    },
    agreementUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/agreement`;
    },
    advertisingUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/advertising`;
    },
    cookieUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/cookie`;
    },
    settingsUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/settings`;
    },
    promoStartText() {
      const start = this.mainSettings?.start_date;
      if (!start) {
        return state.promoStart || '';
      }

      const startDate = new Date(start);
      if (Number.isNaN(startDate.getTime())) {
        return state.promoStart || '';
      }

      const formatter = new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      return `${formatter.format(startDate)} года`;
    },
    isQuestionFormValid() {
      // Проверка имени (минимум 2 символа)
      if (!this.questionForm.name || this.questionForm.name.trim().length < 2) {
        return false;
      }
      
      if (!this.questionForm.email || !this.isEmailStrictValid(this.questionForm.email.trim())) {
        return false;
      }
      
      // Проверка темы
      if (!this.questionForm.subject || this.questionForm.subject === 'Выберите тему') {
        return false;
      }

      // Текст обращения: минимум 2 значимых символа (как validateField), до 600 символов
      const text = (this.questionForm.text || '').trim();
      if (text.length < 2 || text.length > 600) {
        return false;
      }
      
      // Проверка согласия
      if (!this.questionForm.agree_personal_data) {
        return false;
      }
      
      // Проверка ошибок валидации (пустая строка — не ошибка)
      if (
        (this.feedbackErrors.name && this.feedbackErrors.name !== '') ||
        (this.feedbackErrors.email && this.feedbackErrors.email !== '') ||
        (this.feedbackErrors.subject && this.feedbackErrors.subject !== '') ||
        (this.feedbackErrors.text && this.feedbackErrors.text !== '') ||
        (this.feedbackErrors.agree_personal_data && this.feedbackErrors.agree_personal_data !== '')
      ) {
        return false;
      }
      
      return true;
    },
    isResetPasswordFormValid() {
      const email = this.resetPasswordForm.email;
      if (!this.isEmailStrictValid(email)) {
        return false;
      }
      // Проверяем, что нет ошибки валидации (пустая строка или undefined считаются отсутствием ошибки)
      return !this.resetPasswordErrors.email || this.resetPasswordErrors.email === '';
    },
    isLoginFormValid() {
      const email = this.email;
      const password = this.password;
      
      if (!email || email.trim() === '') {
        return false;
      }
      
      // Строгая валидация email
      if (!this.isEmailStrictValid(email)) {
        return false;
      }
      
      if (!password || password.trim() === '') {
        return false;
      }

      if (password.length < 6) {
        return false;
      }
      
      // Проверяем, что нет ошибок валидации (пустая строка или undefined считаются отсутствием ошибки)
      return (!this.loginFormErrors.email || this.loginFormErrors.email === '') && 
             (!this.loginFormErrors.password || this.loginFormErrors.password === '');
    },
    isRegisterFormValid() {
      return (
        registerNameSignificantLength(this.registerForm.first_name) >= 2 &&
        registerNameSignificantLength(this.registerForm.last_name) >= 2 &&
        this.registerForm.email.length > 0 &&
        this.isEmailStrictValid(this.registerForm.email) &&
        isValidRussianMobilePhone(this.registerForm.phone_number) &&
        this.registerForm.is_policy &&
        this.registerForm.agree_rules &&
        !this.errors.first_name &&
        !this.errors.last_name &&
        !this.errors.email &&
        !this.errors.phone_number
      );
    },
    formattedPhoneNumber() {
      // Убираем знак '+' и все нецифровые символы
      const cleaned = this.phoneNumber.replace(/\D/g, '');

      // Проверяем, что номер начинается с '7' и содержит 11 цифр
      if (cleaned.length === 11 && cleaned.startsWith('7')) {
        return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
      }

      return ' ';
    }
  },
  methods: {
    applyPerformanceMode() {
      const root = document.documentElement;
      if (!root) return;
      const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent || '')
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const isMobileViewport = window.matchMedia('(max-width: 767px)').matches;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (isIOSDevice || isMobileViewport || reducedMotion) {
        root.classList.add('performance-lite');
      } else {
        root.classList.remove('performance-lite');
      }
    },
    isEmailStrictValid(email) {
      const normalized = String(email || '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .trim();
      if (!normalized) {
        return false;
      }
      // Строгая проверка формата:
      // - основная часть начинается с буквы/цифры
      // - домен начинается с буквы/цифры
      // - допустимы только стандартные символы email
      const strictRegex = /^[A-Za-z0-9][A-Za-z0-9._%+-]*@[A-Za-z0-9][A-Za-z0-9.-]*\.[A-Za-z]{2,}$/;
      return strictRegex.test(normalized);
    },
    validateField(field) {
      switch (field) {
        case 'first_name': {
          this.errors.first_name =
            registerNameSignificantLength(this.registerForm.first_name) < 2
              ? 'Введите имя (минимум 2 символа)'
              : '';
          break;
        }
        case 'name': {
          if (!this.questionForm.name || this.questionForm.name.trim().length < 2) {
            this.feedbackErrors.name = 'Введите имя (минимум 2 символа)';
          } else {
            this.feedbackErrors.name = '';
          }
          break;
        }
        case 'text': {
          const t = (this.questionForm.text || '').trim();
          this.feedbackErrors.text = t.length < 2 ? 'Поле обязательно для заполнения' : '';
          break;
        }
        case 'subject': {
          const subject = String(this.questionForm.subject || '').trim();
          this.feedbackErrors.subject = !subject || subject === 'Выберите тему'
            ? 'Выберите тему обращения'
            : '';
          break;
        }
        case 'last_name': {
          this.errors.last_name =
            registerNameSignificantLength(this.registerForm.last_name) < 2
              ? 'Введите фамилию (минимум 2 символа)'
              : '';
          break;
        }
        case 'email': {
          const email = this.registerForm.email;
          if (!email || email.trim() === '') {
            this.errors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.errors.email = 'Введите корректный email';
          } else {
            this.errors.email = '';
          }
          break;
        }
        case 'email_login': {
          const email = this.email;
          if (!email || email.trim() === '') {
            this.loginFormErrors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.loginFormErrors.email = 'Введите корректный email';
          } else {
            this.loginFormErrors.email = '';
          }
          break;
        }
        case 'email_feedback': {
          const email = this.questionForm.email;
          if (!email || email.trim() === '') {
            this.feedbackErrors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.feedbackErrors.email = 'Введите корректный email';
          } else {
            this.feedbackErrors.email = '';
          }
          break;
        }
        case 'phone_number': {
          this.registerPhoneTouched = true;
          const raw = this.registerForm.phone_number;
          const d = String(raw || '').replace(/\D/g, '');

          if (d.length === 0) {
            this.errors.phone_number = 'Поле обязательно для заполнения';
            break;
          }
          if (isValidRussianMobilePhone(raw)) {
            this.errors.phone_number = '';
            break;
          }
          /* Любой непустой, но ещё невалидный ввод — подсказка (в т.ч. после blur на «+7 (1»). */
          this.errors.phone_number = russianMobilePhoneHint();
          break;
        }
        case 'agree_rules': {
          this.errors.agree_rules = !this.registerForm.agree_rules ? 'Необходимо согласиться с правилами акции' : '';
          break;
        }
        case 'is_policy': {
          this.errors.is_policy = !this.registerForm.is_policy ? 'Необходимо согласиться на обработку персональных данных' : '';
          break;
        }
      }
    },
    scrollToTop() {
      // Плавно прокручиваем страницу вверх
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    async fetchTopics() {
      try {
        this.topics = await getFeedbackTopics();
      } catch (error) {
        console.error('Error loading topics:', error);
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      this.$nextTick(() => {
        const root = document.querySelector('.popup.popup--question');
        if (!root) return;
        const btn = root.querySelector('[data-feedback-dropdown-btn]');
        const list = root.querySelector('[data-feedback-dropdown-list]');
        if (btn && list) {
          list.style.top = `${btn.offsetHeight}px`;
        }
      });
    },
    selectItem(item) {
      this.selectedText = item.title;
      this.questionForm.subject = item.id;
      this.isChange = true;
      this.isOpen = false;
      this.feedbackErrors.subject = '';
    },
    handleClickOutside(event) {
      const dropdown = document.querySelector('.popup.popup--question [data-feedback-dropdown]');
      if (dropdown && !dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
    handleKeydown(event) {
      if (event.key === 'Tab' || event.key === 'Escape') {
        this.isOpen = false;
      }
    },
    getClientId() {
      // Проверяем согласие перед получением clientId
      if (!hasCookieConsent()) {
        return;
      }
      if (ANALYTICS_DISABLED) {
        return;
      }
      
      if (typeof ym !== 'undefined') {
        ym(YANDEX_METRIKA_COUNTER_ID, 'getClientID', (clientId) => {
          this.clientId = clientId;
          this.getUTMParams();
        });
      } else {
        console.error('Yandex.Metrica не доступна');
      }
    },
    initScrollAnimations() {
      if (document.documentElement.classList.contains('performance-lite')) {
        this.$nextTick(() => {
          const animatedElements = document.querySelectorAll('[data-animate]');
          animatedElements.forEach(el => {
            const animationType = el.getAttribute('data-animate');
            el.classList.add('animate-on-scroll', `animate-${animationType}`, 'is-animated');
          });
        });
        return;
      }
      // Инициализируем анимации при скролле
      this.$nextTick(() => {
        const observerOptions = {
          root: null,
          rootMargin: '0px 0px 200px 0px',
          threshold: 0.01
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-animated');
              // Отключаем наблюдение после анимации (once: true)
              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        // Находим все элементы с атрибутом data-animate
        const animatedElements = document.querySelectorAll('[data-animate]');
        animatedElements.forEach(el => {
          const animationType = el.getAttribute('data-animate');
          const delay = el.getAttribute('data-animate-delay') || '0';
          
          el.classList.add('animate-on-scroll', `animate-${animationType}`);
          
          // Устанавливаем задержку
          if (delay !== '0') {
            const delayNum = parseInt(delay, 10);
            // Если задержка в стандартных значениях (100, 200, 300, 400, 500), используем класс
            if ([100, 200, 300, 400, 500].includes(delayNum)) {
              el.classList.add(`animate-delay-${delay}`);
            } else {
              // Для других значений используем inline style
              el.style.transitionDelay = `${delayNum / 1000}s`;
            }
          }
          
          observer.observe(el);
        });
      });
    },
    // executeAdriverEvent(page) {
    //   const sidMapping = {
    //     rules_click: 'rules_click',
    //     go: 'go',
    //     signup_sentform_success: 'signup_sentform_success',
    //     check_download_success: 'check_download_success',
    //   };
    //
    //   if (!sidMapping[page]) return;
    //
    //   const sid = 230164; // ваш статический sid
    //   const bt = 62; // ваш статический bt
    //   const sz = sidMapping[page];
    //
    //   // Вызов Adriver-кода
    //   (function (e, n) {
    //     function o(e, n, o) {
    //       n = n || "&";
    //       o = o || "=";
    //       var d = [];
    //       for (var r in e)
    //         if (Object.prototype.hasOwnProperty.call(e, r)) {
    //           d.push(r + o + encodeURIComponent(e[r]));
    //         }
    //       return d.join(n);
    //     }
    //     function d(e, n) {
    //       var o = e.cookie.match("(^|;) ?" + n + "=([^;]*)(;|$)");
    //       return o ? decodeURIComponent(o[2]) : null;
    //     }
    //     var r,
    //         t,
    //         i,
    //         c,
    //         u;
    //     (r = e),
    //         (t = n),
    //         (i = document.domain),
    //         (c = { tail256: document.referrer || "unknown" }),
    //     void 0 !==
    //     (u = (function (e) {
    //       var n = {};
    //       if (e) {
    //         var o = e.split("&");
    //         for (var d in o)
    //           if (Object.prototype.hasOwnProperty.call(o, d)) {
    //             var r = o[d].split("=");
    //             void 0 !== r[0] &&
    //             void 0 !== r[1] &&
    //             (n[r[0]] = decodeURIComponent(r[1]));
    //           }
    //       }
    //       return n;
    //     })(window.location.search.substring(1))).adrclid && (r.fsid = u.adrclid),
    //     null !== d(document, "adrcid") && (r.cid = d(document, "adrcid")),
    //     t &&
    //     t.id &&
    //     null !== d(document, t.id) &&
    //     (r.suid = i + "_" + encodeURIComponent(d(document, t.id))),
    //         t && t.gid1
    //             ? (r.gid1 = t.gid1)
    //             : null !== d(document, "_ga") &&
    //             (r.gid1 = encodeURIComponent(d(document, "_ga"))),
    //         t && t.yid1
    //             ? (r.yid1 = t.yid1)
    //             : null !== d(document, "_ym_uid") &&
    //             (r.yid1 = encodeURIComponent(d(document, "_ym_uid"))),
    //         (r.loc = encodeURIComponent(window.location.href)),
    //     r.custom && (r.custom = o(r.custom, ";")),
    //         (function (e, n) {
    //           !(function (e) {
    //             if (
    //                 ((e = e.split("![rnd]").join(~~(1e6 * Math.random()))),
    //                 document.createElement && document.body)
    //             ) {
    //               var n = document.createElement("img");
    //               (n.style.position = "absolute"),
    //                   (n.style.display = "none"),
    //                   (n.style.width = n.style.height = "0px"),
    //                   n.setAttribute("referrerpolicy", "no-referrer-when-downgrade"),
    //                   (n.src = e),
    //                   document.body.appendChild(n);
    //             } else {
    //               var o = new Image();
    //               o.setAttribute("referrerpolicy", "no-referrer-when-downgrade"),
    //                   (o.src = e);
    //             }
    //           })(
    //               "https://ad.adriver.ru/cgi-bin/rle.cgi?" +
    //               e +
    //               "&rnd=![rnd]" +
    //               (n ? "&" + n : "")
    //           );
    //         })(o(r), o(c));
    //   })({ sid: sid, bt: bt, sz: sz }, { id: "", gid1: "", yid1: "" });
    // },
    // executeDSPCounterEvent(siteArea) {
    //   const sid = 230164; // ваш статический sid
    //   const siteAreaMapping = {
    //     '30_sec': 'TJCuegy2',
    //     'login_success': 'qh1jImpT',
    //     'check_upload_success': 'hAf9oUO0',
    //     'buttons_click': 'bG46a4ie',
    //     'faq_click': 'USZY4vWn',
    //   };
    //
    //   const siteAreaId = siteAreaMapping[siteArea] || 'USZY4vWn'; // если не нашли, использовать дефолтный
    //   // Проверка и отложенный вызов если DSPCounter еще не загружен
    //   const checkDSPCounter = setInterval(() => {
    //     if (window.DSPCounter) {
    //       clearInterval(checkDSPCounter);
    //       window.DSPCounter('send', {
    //         'sid': sid,
    //         'site_area': siteAreaId,
    //         'user_id': '',
    //         'lead_id': '',
    //         'order_sum': ''
    //       });
    //     }
    //   }, 100); // проверяем каждые 100ms
    // },
    handleDynamicButtonClick(event) {
      if (event.target.id === 'apm-close-widget-button') {
        this.$sendMetrik('reachGoal', 'upload_check_closed');
        state.isUploadOpened = false;
        document.body.classList.remove('is-upload-widget-opened');
        window.dispatchEvent(new CustomEvent('promo-apm-upload-modal-closed'));
        return;
      }
      tryCloseApmModalOnBackdropClick(event);
    },
    startCheckingForNewChecks() {
      // Если уже идет проверка, не запускаем ещё раз
      if (this.checkInterval) return;

      this.checkInterval = setInterval(async () => {
        try {
          const checksData = await getUserChecks(this.checkOffset, this.checkLimit);
          if (checksData.count && checksData.count !== state.checksTotal) {
            // Обновляем данные, если количество чеков изменилось
            state.checksTotal = checksData.count;
            state.checks.results = checksData.results;

            // Останавливаем таймер
            this.stopCheckingForNewChecks();

            // Очищаем флаг ожидания
            state.checkSoon = false;
          }
        } catch (error) {
          console.error('Error checking for new checks:', error);
        }
      }, 5000); // Проверяем каждые 5 секунд
    },
    stopCheckingForNewChecks() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }
    },
    getUTMParams() {
      const params = new URLSearchParams(window.location.search);
      const utmParams = {
        utm_source: params.get('utm_source'),
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign'),
        utm_term: params.get('utm_term'),
        utm_content: params.get('utm_content'),
        click_id: params.get('click_id')
      };

      // Фильтрация null значений
      const filteredParams = Object.fromEntries(
          Object.entries(utmParams).filter(([, value]) => value !== null)
      );

      // Если есть UTM параметры, сохраняем их в localStorage
      if (Object.keys(filteredParams).length > 0) {
        const paramsString = new URLSearchParams(filteredParams).toString();
        localStorage.setItem('registration_params', paramsString);
        this.utmParams = filteredParams;
      } else {
        // Если нет параметров в URL, пытаемся загрузить из localStorage
        const savedParams = localStorage.getItem('registration_params');
        if (savedParams) {
          const savedParamsObj = Object.fromEntries(new URLSearchParams(savedParams));
          this.utmParams = savedParamsObj;
        } else {
          this.utmParams = {};
        }
      }

      // Добавляем clientId в utmParams после его получения
      if (this.clientId) {
        this.utmParams.client_id = this.clientId;
      }
    },
    async fetchOptions() {
      try {
        this.options = await fetchTopics(10, 0);
      } catch (error) {
        console.error("Ошибка загрузки тем:", error);
      }
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);

      this.responseError = '';

      // Фильтрация по разрешённым типам файлов и размеру
      const MAX_SIZE = 5 * 1024 * 1024; // 5 MB
      let hasOversize = false;

      const validFiles = files.filter(file => {
        const isValidType = /\.(jpe?g|png|gif|tiff|webp|pdf|heic|heif|avif)$/i.test(file.name);
        const isValidSize = file.size <= MAX_SIZE;
        if (!isValidSize) {
          hasOversize = true;
        }
        return isValidType && isValidSize;
      });

      if (hasOversize) {
        this.responseError = 'Максимальный размер: 5MB';
      }

      const MAX_FEEDBACK_FILES = 10;
      const slotsLeft = Math.max(0, MAX_FEEDBACK_FILES - this.filePreviews.length);
      if (slotsLeft === 0) {
        this.responseError = 'Прикреплено максимальное количество файлов';
        event.target.value = '';
        return;
      }
      const filesToAdd =
        validFiles.length > slotsLeft ? validFiles.slice(0, slotsLeft) : validFiles;

      // Добавляем файлы в состояние и показываем их превью
      filesToAdd.forEach(file => {
        const preview = {
          file,
          name: file.name,
          type: file.type,
          preview: URL.createObjectURL(file) // для изображений
        };
        this.filePreviews.push(preview);
        this.questionForm.files.push(file);
      });
      event.target.value = '';
    },

    // Удаление файла
    removeFile(index) {
      // Удаляем файл из массива файлов
      this.filePreviews.splice(index, 1);
      this.questionForm.files.splice(index, 1);
    },
    handleRulesButtonClick() {
      this.$sendMetrik('reachGoal', 'Rules_Click');
    },
    addBodyClass() {
      document.body.classList.add('is-popup-opened');
    },
    removeBodyClass() {
      document.body.classList.remove('is-popup-opened');
    },
    async logout() {
      state.checkSoon = false;
      state.checksTotal = 0;
      state.checks = {
        count: 0,
        next: null,
        previous: null,
        results: [],
      };
      state.user = {
        address: {
          apartment: null,
          city: null,
          email: null,
          fio: null,
          house: null,
          phone_number: null,
          street: null,
          zip_code: null,
        },

        first_name: null,
        last_name: null,
        phone_number: null,
        email: null,
        gender: null,
        is_verification: null,
        birthday: null,
        id: null,
        uuid: null,
        is_possible_to_upload_receipt: null,
        address_is_filled: null,
        promocode: null,
        referral_id: null,
        referral_link: null,
        balance: null,
        privilege_level: null,
        need_points: null,
        checks_count: 0,
        approved_checks_count: 0,
        rejected_checks_count: 0,
        all_cash: 0
      };
      const widget = document.getElementById('apm-widget');
      if (widget) {
        widget.innerHTML = ''; // Очистка содержимого виджета
      }

      // Удаление токена
      removeToken();
      
      // Очистка всех форм
      this.questionForm = {
        name: '',
        email: '',
        text: '',
        agree_personal_data: false,
        agree_to_advertising: false,
        subject: '',
        files: []
      };
      this.filePreviews = [];
      this.email = '';
      this.password = '';
      this.loginFormErrors = {};
      this.feedbackErrors = {};
      this.resetPasswordErrors = {};
      this.errors = {};
      this.responseError = '';
      
      // Обновление состояния пользователя
      this.user = null;
      this.toggleMobileNav(); // Закрытие мобильного меню
      
      // Ожидание завершения обновления DOM
      await this.$nextTick();

      // Выполняем перенаправление на главную
      if (this.$route.path !== '/') {
        this.$router.push('/');
      } else {
        window.location.reload();
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    formatText(text) {
      // Замена переносов строк на <br>
      let formattedText = text.replace(/\r?\n/g, '<br>');

      // Регулярное выражение для поиска URL
      const urlPattern = /(https?:\/\/[^\s]+)/g;

      // Замена URL на HTML-ссылки
      formattedText = formattedText.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');

      return formattedText;
    },
    clearError(field) {
      this.errors = { ...this.errors, [field]: null };
    },
    clearFeedbackError(field) {
      if (!this.feedbackErrors) {
        this.feedbackErrors = {};
      }
      this.feedbackErrors[field] = '';
    },
    redirectToPrivatePage() {
      this.$router.push('/private');
      this.isMobileNavOpened = false;
    },
    redirectToHomePage() {
      return this.$router.push('/');
    },
    removeSpacesFirstName() {
      const input = event.target.value.trimStart();
      this.registerForm.first_name = input.length > 0 ? input : '';
    },
    removeSpacesLastName() {
      const input = event.target.value.trimStart();
      this.registerForm.last_name = input.length > 0 ? input : '';
    },
    removeSpacesName() {
      const input = event.target.value.trimStart();
      this.questionForm.name = input.length > 0 ? input : '';
    },
    initFloatingLabels() {
      this.$nextTick(() => {
        const floatingFields = document.querySelectorAll('.field-item--floating');
        floatingFields.forEach(fieldItem => {
          const input = fieldItem.querySelector('input, textarea');
          if (!input) return;

          // Функция для проверки и обновления состояния
          const updateFloatingState = () => {
            const hasValue = input.value && input.value.trim().length > 0;
            const hasFocus = document.activeElement === input;
            
            if (hasValue || hasFocus) {
              fieldItem.classList.add('field-item--active');
            } else {
              fieldItem.classList.remove('field-item--active');
            }
          };

          // Удаляем старые обработчики, если они есть
          if (input._floatingHandlers) {
            input.removeEventListener('focus', input._floatingHandlers.focus);
            input.removeEventListener('blur', input._floatingHandlers.blur);
            input.removeEventListener('input', input._floatingHandlers.input);
            input.removeEventListener('change', input._floatingHandlers.change);
          }

          // Создаем новые обработчики
          const focusHandler = () => {
            fieldItem.classList.add('field-item--active');
          };
          const blurHandler = () => {
            updateFloatingState();
          };
          const inputHandler = () => {
            updateFloatingState();
          };
          const changeHandler = () => {
            updateFloatingState();
          };

          // Сохраняем ссылки на обработчики
          input._floatingHandlers = {
            focus: focusHandler,
            blur: blurHandler,
            input: inputHandler,
            change: changeHandler
          };

          // Добавляем обработчики
          input.addEventListener('focus', focusHandler);
          input.addEventListener('blur', blurHandler);
          input.addEventListener('input', inputHandler);
          input.addEventListener('change', changeHandler);

          // Проверяем начальное состояние
          updateFloatingState();
          requestAnimationFrame(updateFloatingState);
          setTimeout(updateFloatingState, 120);
        });
      });
    },
    formatBirthdayInput(event) {
      let value = event.target.value.replace(/\D/g, ''); // Оставляем только цифры

      // Ограничиваем длину до 8 символов
      if (value.length > 8) {
        value = value.slice(0, 8);
      }

      // Форматируем строку в DD-MM-YYYY
      let formattedValue = value;

      if (value.length >= 2) {
        formattedValue = value.slice(0, 2) + '-' + value.slice(2); // Добавляем дефис после двух первых цифр
      }
      if (value.length >= 5) {
        formattedValue = formattedValue.slice(0, 5) + '-' + formattedValue.slice(5); // Добавляем дефис после пяти символов
      }

      // Удаляем дефис, если длина строки меньше 5 или 2
      if (formattedValue.length < 5) {
        formattedValue = formattedValue.replace('-', '');
      }

      if (formattedValue.length < 2) {
        formattedValue = formattedValue.replace('-', '');
      }

      // Присваиваем форматированное значение в форму
      this.registerForm.birthday = formattedValue;
    },
    convertBirthdayFormat(date) {
      if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
        const [day, month, year] = date.split('-');
        return `${year}-${month}-${day}`;
      }
      return date;
    },
    triggerQrScan() {
      this.$sendMetrik('reachGoal', 'Check_Click');
      adRiver.trackRegisterReceiptClick();
      // this.executeDSPCounterEvent('buttons_click');
      if (state.promoStatus == 'start') {
        const qrElement = document.getElementById('apm-scan-qr');
        if (qrElement) {
          state.isUploadOpened = true;
          document.body.classList.add('is-upload-widget-opened');
          qrElement.click();
        }
      } else if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.showPromoNotStarted = true;
      } else if (state.promoStatus == 'end') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.showPromoEnd = true;
      }
    },
    initQrWidget() {
      if (!document.getElementById('apm-scan-qr')) {
        qrWidget.init('apm-widget', {
          api: APMCHECK_API_URL,
          apiKey: APMCHECK_API_KEY,
          userUuid: this.userUuid,
          callbacks: {
            onReceiptSentSuccess: () => {
              adRiver.trackReceiptUploadSuccess();
              this.$sendMetrik('reachGoal', 'upload_check_succes');
              if (typeof _txq !== 'undefined') {
                _txq.push(['track', 'check_download_success']);
              }
              // this.executeDSPCounterEvent('check_upload_success');
              // this.executeAdriverEvent('check_download_success');
              state.checkSoon = true;
              state.isUploadOpened = false;
              document.body.classList.remove('is-upload-widget-opened');
              this.startCheckingForNewChecks();
            },
            onReceiptSentError: () => {
              state.isUploadOpened = false;
              document.body.classList.remove('is-upload-widget-opened');
            }
          }
        });
      }
    },
    toggleMobileNav() {
      this.isMobileNavOpened = !this.isMobileNavOpened;
    },
    openAccountPopup() {
      this.addBodyClass();
      this.AccountPopup = true;
    },
    closeAccountPopup() {
      this.removeBodyClass();
      this.AccountPopup = false;
    },
    openQuestionPopup() {
      // this.executeDSPCounterEvent('buttons_click');
      this.addBodyClass();
      this.showQuestionPopup = true;
      this.responseError = '';
      const fb = feedbackIdentityPrefill(this.user);
      this.questionForm.name = fb.name;
      this.questionForm.email = fb.email;
      this.$nextTick(() => {
        this.initFloatingLabels();
      });
    },
    closeQuestionPopup() {
      this.removeBodyClass();
      this.showQuestionPopup = false;
      this.responseError = '';
      this.resetForm();
      // Очищаем файлы и их превью
      this.filePreviews = [];
      this.questionForm.files = [];
    },
    openQuestionPopupSuccess() {
      // adRiver.trackQuestionFormSubmit()
      this.$sendMetrik('reachGoal', 'Feedback_SentForm_Success');
      this.addBodyClass();
      this.showQuestionPopupSuccess = true;
      this.resetForm();
    },
    closeQuestionPopupSuccess() {
      this.removeBodyClass();
      this.showQuestionPopupSuccess = false;
      this.resetForm();
    },
    openResetPasswordPopup() {
      if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.responseError = '';
        this.showPromoNotStarted = true;
        return;
      }
      this.resetPasswordForm.email = '';
      this.resetPasswordErrors = {};
      this.responseError = '';
      this.showResetPasswordPopup = true;
      this.closeLoginPopup();
      this.addBodyClass();
      this.$nextTick(() => {
        this.initFloatingLabels();
      });
    },
    closeResetPasswordPopup() {
      this.removeBodyClass();
      this.showResetPasswordPopup = false;
      this.resetForm();
    },
    openResetPasswordPopupSuccess() {
      this.addBodyClass();
      this.showResetPasswordSuccess = true;
    },
    closeResetPasswordPopupSuccess() {
      this.resetPasswordEmail = null;
      this.removeBodyClass();
      this.showResetPasswordSuccess = false;
      this.resetForm();
    },
    closeShowPromoNotStarted() {
      this.removeBodyClass();
      this.showPromoNotStarted = false;
    },
    closeShowPromoEnd() {
      this.removeBodyClass();
      this.showPromoEnd = false;
    },
    closeShowSpecialPrizeEnding() {
      this.removeBodyClass();
      this.showSpecialPrizeEnding = false;
    },
    handleSpecialPrizeUploadClick() {
      this.closeShowSpecialPrizeEnding();
      const token = getToken();
      if (!token) {
        this.addBodyClass();
        this.showCommonLoginPopup = true;
        state.showCommonLoginPopup = true;
        return;
      }
      this.$nextTick(() => {
        this.triggerQrScan();
      });
    },
    scheduleSpecialPrizeEndingPopup() {
      if (this.specialPrizePopupTimer) {
        clearTimeout(this.specialPrizePopupTimer);
        this.specialPrizePopupTimer = null;
      }

      if (this.isTelegramPage || this.$route?.path !== '/') {
        return;
      }

      const remaining = Number(this.mainSettings?.special_price_remaining);
      const shouldShow = Number.isFinite(remaining) && remaining >= 1 && remaining <= 10;

      if (!shouldShow) {
        return;
      }

      if (sessionStorage.getItem('specialPrizeEndingShown') === '1') {
        return;
      }

      this.specialPrizePopupTimer = setTimeout(() => {
        this.addBodyClass();
        this.showSpecialPrizeEnding = true;
        sessionStorage.setItem('specialPrizeEndingShown', '1');
      }, 5000);
    },
    async submitQuestion() {
      this.responseError = '';
      try {
        this.feedbackErrors = {};

        if (!this.questionForm.name || this.questionForm.name.trim().length < 2) {
          this.feedbackErrors.name = 'Введите имя (минимум 2 символа)';
        }
        if (!this.questionForm.email || !this.questionForm.email.trim()) {
          this.feedbackErrors.email = 'Поле обязательно для заполнения';
        } else if (!this.isEmailStrictValid(this.questionForm.email.trim())) {
          this.feedbackErrors.email = 'Введите корректный email';
        }
        const textTrimmed = (this.questionForm.text || '').trim();
        if (!textTrimmed) {
          this.feedbackErrors.text = 'Введите текст обращения';
        } else if (textTrimmed.length < 2) {
          this.feedbackErrors.text = 'Поле обязательно для заполнения';
        } else if (textTrimmed.length > 600) {
          this.feedbackErrors.text = 'Текст обращения не более 600 символов';
        }
        if (!this.questionForm.agree_personal_data) {
          this.feedbackErrors.agree_personal_data = 'Необходимо согласиться с политикой обработки персональных данных';
        } else {
          delete this.feedbackErrors.agree_personal_data;
        }
        if (!this.questionForm.subject || this.questionForm.subject === 'Выберите тему') {
          this.feedbackErrors.subject = 'Выберите тему обращения';
        }

        const hasErrors = Object.keys(this.feedbackErrors).some(key => this.feedbackErrors[key] && this.feedbackErrors[key] !== '');
        if (hasErrors) {
          return;
        }

        this.formSending = true;
        await sendFeedback({
          email: this.questionForm.email.trim(),
          name: this.questionForm.name.trim(),
          text: textTrimmed,
          subject: this.questionForm.subject,
          agree_personal_data: this.questionForm.agree_personal_data,
          agree_to_advertising: this.questionForm.agree_to_advertising,
          files: this.questionForm.files,
        });

        this.closeQuestionPopup();
        this.openQuestionPopupSuccess();
      } catch (error) {
        this.responseError = formatFeedbackSendError(error.response?.data);
      } finally {
        this.formSending = false;
      }
    },
    validateResetPasswordEmail() {
      const email = this.resetPasswordForm.email;
      
      // Очищаем ошибки
      if (!this.resetPasswordErrors) {
        this.resetPasswordErrors = {};
      }
      
      if (!email || email.trim() === '') {
        this.resetPasswordErrors.email = 'Поле обязательно для заполнения';
        return;
      }
      
      // Строгая валидация формата email
      if (!this.isEmailStrictValid(email)) {
        this.resetPasswordErrors.email = 'Введите корректный email';
        return;
      }
      
      // Если все проверки пройдены, очищаем ошибку
      this.resetPasswordErrors.email = '';
    },
    async submitResetPassword() {
      try {
        this.formSending = true;
        const { email } = this.resetPasswordForm;
        this.resetPasswordErrors = {};
        this.responseError = '';

        // Валидация email
        this.validateResetPasswordEmail();
        
        // Если есть ошибки валидации - не отправляем
        if (this.resetPasswordErrors.email) {
          this.formSending = false;
          return;
        }

        // Отправка данных формы через API
        await sendResetPassword({ email: email });

        // Успешная отправка, здесь можно закрыть попап
        this.resetPasswordEmail = email;
        this.closeResetPasswordPopup();
        this.openResetPasswordPopupSuccess();
        this.formSending = false;
      } catch (error) {
        this.formSending = false;
        if (error.response && error.response.data) {
          this.responseError = error.response.data.detail;
        }
      }
    },
    resetForm() {
      this.filePreviews = [];
      const fb = feedbackIdentityPrefill(this.user);
      this.questionForm = {
        name: fb.name,
        email: fb.email,
        text: '',
        subject: '',
        agree_personal_data: false,
        agree_to_advertising: false,
        files: []
      };
      this.selectedText = 'Тема обращения';
      this.isChange = false;

      this.phone_number = '';
      this.password = '';

      this.registerForm = {
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        is_policy: false,
        agree_rules: false,
        agree_to_advertising: false
      };
      this.registerPhoneTouched = false;

      this.resetPasswordForm = {
        phone_number: '',
      };

      this.feedbackErrors = {};
    },
    toggleAccordion(event) {
      event.target.classList.toggle('is-opened');
      const textBlock = event.target.nextElementSibling;
      textBlock.classList.toggle('is-opened');
    },
    handleScrollThrottled() {
      if (this._handleScrollRafId) return;
      this._handleScrollRafId = requestAnimationFrame(() => {
        this._handleScrollRafId = null;
        this.handleScroll();
      });
    },
    handleScroll() {
      this.isHeaderScrolled = window.scrollY > this.scrollThreshold;

      const sections = document.querySelectorAll('.register-section');

      let currentSectionIndex = -1;

      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        if (rect.top - 400 <= 0 && rect.bottom > 0) {
          currentSectionIndex = index;
        }
      });

      if (currentSectionIndex !== -1) {
        this.activeSectionAccount = currentSectionIndex;
        // Добавляем класс 'is-scrolled' ко всем предыдущим секциям
        for (let i = 0; i < currentSectionIndex; i++) {
          this.sections[i].scrolled = true;
        }
        // Убираем класс 'is-scrolled' со всех следующих секций
        for (let i = currentSectionIndex; i < this.sections.length; i++) {
          this.sections[i].scrolled = false;
        }
      } else {
        this.activeSectionAccount = 0;
        this.sections.forEach(section => section.scrolled = false);
      }
    },
    scrollToSection(index) {
      const section = this.$refs['section-' + index][0];
      window.scrollTo({
        top: section.offsetTop,
        behavior: 'smooth'
      });
      this.activeSectionIndex = index;
    },
    isActive(index) {
      return this.activeSectionIndex === index;
    },
    isScrolled(index) {
      return index < this.activeSectionIndex;
    },
    async checkAuthentication() {
      const token = getToken();
      if (token) {
        try {
          const userInfo = await getUserInfo();
          this.user = userInfo;
          state.user = {
            address: {
              apartment: userInfo.address?.apartment ?? "",
              city: userInfo.address?.city ?? "",
              email: userInfo.address?.email ?? "",
              fio: userInfo.address?.fio ?? "",
              house: userInfo.address?.house ?? "",
              phone_number: userInfo.address?.phone_number ?? "",
              street: userInfo.address?.street ?? "",
              zip_code: userInfo.address?.zip_code ?? "",
            },

            id: userInfo.id,
            uuid: userInfo.uuid,
            first_name: userInfo.first_name,
            last_name: userInfo.last_name,
            phone_number: userInfo.phone_number,
            email: userInfo.email,
            gender: userInfo.gender ?? null,
            is_verification: userInfo.is_verification ?? null,
            birthday: userInfo.birthday,
            is_possible_to_upload_receipt: userInfo.is_possible_to_upload_receipt,
            address_is_filled: userInfo.address_is_filled,
            promocode: userInfo.promocode,
            referral_id: userInfo.referral_id,
            referral_link: userInfo.referral_link,
            balance: userInfo.balance,
            privilege_level: userInfo.privilege_level,
            need_points: userInfo.need_points,
            checks_count: userInfo.checks_count,
            approved_checks_count: userInfo.approved_checks_count,
            rejected_checks_count: userInfo.rejected_checks_count,
            all_cash: userInfo.all_cash
          }
        } catch (error) {
          if (error.response && error.response.data) {
            this.responseError = error.response.data.detail;
          }
        }
      }
    },
    formatDateRange(start_date, end_date) {
      const start = new Date(start_date);
      const end = new Date(end_date);

      const format = (date) =>
          String(date.getUTCDate()).padStart(2, "0") + "." +
          String(date.getUTCMonth() + 1).padStart(2, "0") + "." +
          date.getUTCFullYear();

      return `${format(start)} – ${format(end)}`;
    },
    formatDateStart(start_date) {
      const start = new Date(start_date);

      return String(start.getUTCDate()).padStart(2, "0") + "." +
          String(start.getUTCMonth() + 1).padStart(2, "0") + "." +
          start.getUTCFullYear();
    },
    formatDateEnd(end_date) {
      const end = new Date(end_date);

      return String(end.getUTCDate()).padStart(2, "0") + "." +
          String(end.getUTCMonth() + 1).padStart(2, "0") + "." +
          end.getUTCFullYear();
    },
    async fetchTimerData() {
      // Объявление функции вынесено в корень метода
      function getMonthNameInGenitive(month) {
        const monthNames = [
          'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
          'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
        ];
        return monthNames[month];
      }

      try {
        const { start_date, end_date, status } = await getMainSettings();
        const now = new Date();
        const startDate = new Date(start_date);
        const endDate = new Date(end_date);
        const mappedStatus = status === 'future'
          ? 'not-started'
          : status === 'active'
            ? 'start'
            : status === 'past'
              ? 'end'
              : '';

        // Преобразование строки в объект Date
        const date = new Date(end_date);

        // Форматирование даты в формат "дд.мм.гггг"
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        const formattedDate = `${day}.${month}.${year}`;

        this.state.endDate = formattedDate;

        // Преобразование строки в объект Date
        const dateStart = new Date(start_date);

      // Форматирование даты в формат "дд.мм.гггг"
        const dayStart = dateStart.getDate().toString().padStart(2, '0');
        const monthStart = (dateStart.getMonth() + 1).toString().padStart(2, '0');
        const yearStart = dateStart.getFullYear();

        const formattedDateStart = `${dayStart}.${monthStart}.${yearStart}`;

        this.state.startDate = formattedDateStart;

        // Создаем строку формата "C 1 июня по 31 июля 2025 г."
        const periodText = `C ${dateStart.getDate()} ${getMonthNameInGenitive(dateStart.getMonth())} по ${date.getDate()} ${getMonthNameInGenitive(date.getMonth())} ${date.getFullYear()} г.`;

        this.state.periodText = periodText;


        if (now >= endDate || mappedStatus === 'end') {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.timerMessage = 'Акция завершилась';
          this.promoDates = startDate + ' - ' + end_date;
          state.promoStatus = 'end'
          state.promoEnd = this.formatDateEnd(end_date);
        } else if (now < startDate || mappedStatus === 'not-started') {
          this.calculateTimeDifference(now, startDate);
          this.timerMessage = 'до начала акции';
          this.promoDates = start_date + ' - ' + end_date;
          state.promoStatus = 'not-started'
          state.promoStart = start_date;
          state.promoStart = this.formatDateStart(start_date);
        } else if (mappedStatus === 'start' || (!mappedStatus && now >= startDate && now < endDate)) {
          this.calculateTimeDifference(now, endDate);
          this.timerMessage = 'До окончания приема чеков';
          this.promoDates = start_date + ' - ' + end_date;
          state.promoStatus = 'start'
        } else {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.timerMessage = 'Акция завершилась';
          this.promoDates = startDate + ' - ' + end_date;
          state.promoStatus = 'end'
          state.promoEnd = this.formatDateEnd(end_date);
        }
        this.promoDates = this.formatDateRange(start_date, end_date);

        const promoShown = sessionStorage.getItem('promoShown');
        if (!promoShown && state.promoStatus === 'end') {
          this.showPromoEnd = true;
          sessionStorage.setItem('promoShown', 'true');
        }

        const promoFuturePopupShown = sessionStorage.getItem('promoFuturePopupShown');
        if (!promoFuturePopupShown && status === 'future') {
          this.showPromoNotStarted = true;
          sessionStorage.setItem('promoFuturePopupShown', 'true');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.responseError = error.response.data.detail;
        }
      }
    },
    calculateTimeDifference(start, end) {
      const diff = end - start;

      const totalSeconds = Math.floor(diff / 1000);
      this.days = Math.floor(totalSeconds / (3600 * 24));
      this.hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
      this.minutes = Math.floor((totalSeconds % 3600) / 60);
    },
    /** Регистрация закрыта: акция завершена по статусу или по дате окончания в main settings. */
    isPromoClosedForRegistration() {
      return state.promoStatus === 'end' || this.isPastMainSettingsEndDate();
    },
    /** Кнопка отправки формы регистрации и переход в форму регистрации. */
    isRegisterFlowAllowed() {
      return state.promoStatus === 'start' && !this.isPastMainSettingsEndDate();
    },
    openLoginPopup() {
      this.email = '';
      this.password = '';
      this.loginFormErrors = {};
      this.responseError = '';
      this.showCommonLoginPopup = false;
      state.showCommonLoginPopup = false;
      if (
        state.promoStatus == 'start'
        || state.promoStatus == 'end'
        || this.isPastMainSettingsEndDate()
      ) {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.showLoginPopup = true;
        this.$nextTick(() => {
          this.initFloatingLabels();
        });
      } else if (state.promoStatus == 'not-started' || !state.promoStatus || state.promoStatus == 'future') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.showPromoNotStarted = true;
      }
    },
    closeLoginPopup() {
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'enter_сancel']);
      }
      this.removeBodyClass();
      this.showLoginPopup = false;
      this.responseError = '';
      this.resetForm();
    },
    closeCommonLoginPopup() {
      this.showCommonLoginPopup = false;
      state.showCommonLoginPopup = false;
      this.removeBodyClass();
      this.responseError = '';
      this.resetForm();
    },
    openRegisterPopup() {
      this.showCommonLoginPopup = false;
      state.showCommonLoginPopup = false;
      if (this.isPromoClosedForRegistration()) {
        this.showLoginPopup = false;
        this.responseError = '';
        this.resetForm();
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.showPromoEnd = true;
        return;
      }
      if (state.promoStatus == 'start') {
        this.showRegisterPopup = true;
        this.closeLoginPopup();
        this.responseError = '';
        this.addBodyClass();
        this.$nextTick(() => {
          this.initFloatingLabels();
        });
      } else if (state.promoStatus == 'not-started' || !state.promoStatus || state.promoStatus == 'future') {
        this.showLoginPopup = false;
        this.responseError = '';
        this.resetForm();
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.showPromoNotStarted = true;
      }
    },
    isPastMainSettingsEndDate() {
      const raw = this.mainSettings?.end_date;
      if (!raw) return false;
      const t = new Date(raw).getTime();
      return !Number.isNaN(t) && Date.now() >= t;
    },
    openCommonLoginPopup() {
      this.responseError = '';
      if (state.promoStatus == 'not-started' || !state.promoStatus || state.promoStatus == 'future') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.showPromoNotStarted = true;
        return;
      }
      this.showCommonLoginPopup = true;
      state.showCommonLoginPopup = true;
      this.$nextTick(() => {
        this.initFloatingLabels();
      });
      this.addBodyClass();
    },
    closeRegisterPopup() {
      this.$sendMetrik('reachGoal', 'SignUp_Cancel');
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'registration_сancel']);
      }
      this.removeBodyClass();
      this.showRegisterPopup = false;
      this.responseError = '';
      this.resetForm();
    },
    closeRegisterFinishPopup() {
      this.removeBodyClass();
      this.showRegisterPopup = false;
      this.responseError = '';
      this.resetForm();
    },
    openRegisterPopupSuccess() {
      // this.executeDSPCounterEvent('login_success');
      adRiver.trackUserRegistrationSuccess();
      this.$sendMetrik('reachGoal', 'SignUp_SentForm_Success');
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'registration_success']);
      }
      // this.executeAdriverEvent('signup_sentform_success');
      this.addBodyClass();
      this.showRegisterPopupSuccess = true;
      this.responseError = '';
    },
    closeRegisterPopupSuccess() {
      this.removeBodyClass();
      this.showRegisterPopupSuccess = false;
      this.responseError = '';
      this.resetForm();
    },
    openLoginFromRegisterSuccess() {
      this.showRegisterPopupSuccess = false;
      this.responseError = '';
      this.resetForm();
      this.addBodyClass();
      this.showLoginPopup = true;
    },
    async loadFAQ() {
      try {
        const data = await fetchFAQ();
        this.faq = data.results.map(item => ({
          question: item.question,
          answer: item.answer
        }));
      } catch (error) {
        console.error('Error fetching winners:', error);
      }
    },
    validateLoginEmail() {
      const email = this.email;
      
      if (!this.loginFormErrors) {
        this.loginFormErrors = {};
      }
      
      if (!email || email.trim() === '') {
        this.loginFormErrors.email = 'Поле обязательно для заполнения';
        return;
      }
      
      // Строгая валидация email
      if (!this.isEmailStrictValid(email)) {
        this.loginFormErrors.email = 'Введите корректный email';
        return;
      }
      
      // Если все проверки пройдены, очищаем ошибку
      this.loginFormErrors.email = '';
    },
    validateLoginPassword() {
      this.password = (this.password || '').replace(/\s/g, '');
      const password = this.password;

      if (!this.loginFormErrors) {
        this.loginFormErrors = {};
      }

      if (!password) {
        this.loginFormErrors.password = 'Поле обязательно для заполнения';
        return;
      }

      if (password.length < 6) {
        this.loginFormErrors.password = 'Пароль должен быть не менее 6 символов';
        return;
      }

      this.loginFormErrors.password = '';
    },
    async login() {
      try {
        this.formSending = true;
        this.loginFormErrors = {};
        this.responseError = '';
        
        // Валидация email
        this.validateLoginEmail();
        // Валидация пароля
        this.validateLoginPassword();
        
        // Если есть ошибки - не отправляем запрос
        if (this.loginFormErrors.email || this.loginFormErrors.password) {
          this.formSending = false;
          return;
        }

        await authorize(this.email, this.password);
        setAuthHeader();
        setTimeout(async () => {
          try {
            const userInfo = await getUserInfo();
            if (userInfo) {
              // adRiver.trackAuthorization()
              this.$sendMetrik('reachGoal', 'SignIn_SentForm_Success');
              if (typeof _txq !== 'undefined') {
                _txq.push(['track', 'enter_success']);
              }
              this.userId = userInfo.id;
              this.userUuid = userInfo.uuid;
              this.user = {
                first_name: userInfo.first_name,
                last_name_initial: (userInfo.last_name || '').charAt(0),
              };
              this.questionForm.name = userInfo.first_name;
              this.questionForm.email = userInfo.email;
              this.closeLoginPopup();
              this.initQrWidget();
              // this.executeDSPCounterEvent('login_success');
              setTimeout(async () => {
                this.$router.push('/private');
              }, 400); // 500 мс задержка
              this.removeBodyClass();
            }
          } catch (error) {
            console.error('Error fetching user info', error);
          }
          this.formSending = false;
        }, 900); // 500 мс задержка

      } catch (error) {
        this.formSending = false;
        if (error.response && (error.response.status === 553 || error.response.status === 554)) {
          this.responseError = 'неверный логин или пароль';
        } else if (error.response && error.response.data) {
          this.responseError = error.response.data.detail;
        } else {
          this.responseError = 'Произошла ошибка при авторизации';
        }
      }
    },
    async register() {
      if (this.isPromoClosedForRegistration()) {
        return;
      }
      try {
        this.formSending = true;
        const { first_name, last_name, phone_number, email, is_policy, agree_rules, agree_to_advertising } = this.registerForm;
        this.registrationSuccessEmail = (email || '').trim();

        const formattedPhoneNumber = formatRussianMobileE164(phone_number);

        // Проверки
        this.errors = {};
        if (registerNameSignificantLength(first_name) < 2) {
          this.errors.first_name = 'Введите корректное значение';
        }
        if (registerNameSignificantLength(last_name) < 2) {
          this.errors.last_name = 'Введите корректное значение';
        }
        if (!this.isEmailStrictValid(email)) {
          this.errors.email = 'Поле обязательно для заполнения';
        }
        if (!formattedPhoneNumber) {
          this.errors.phone_number = russianMobilePhoneHint();
        }
        if (!agree_rules) {
          this.errors.agree_rules = 'Необходимо согласиться с правилами акции';
        }
        if (!is_policy) {
          this.errors.is_policy = 'Необходимо согласиться на обработку персональных данных';
        }

        // Если есть ошибки - не отправляем
        if (Object.keys(this.errors).length > 0) {
          this.formSending = false;
          return;
        }

        // Получаем registration_params из localStorage или текущих utmParams
        let registrationParamsString = '';
        const savedParams = localStorage.getItem('registration_params');
        if (savedParams) {
          registrationParamsString = savedParams;
        } else if (Object.keys(this.utmParams).length > 0) {
          registrationParamsString = new URLSearchParams(this.utmParams).toString();
        }

        if (state.ref !== '') {
          this.registerForm.promocode = state.ref;
        }

        // Отправляем запрос с форматированной датой
        // registration_params должен быть строкой согласно документации API
        await register({
          first_name: (first_name || '').trim(),
          last_name: (last_name || '').trim(),
          phone_number: formattedPhoneNumber,
          email,
          registration_params: registrationParamsString || null,
          agree_to_advertising,
          is_policy,
          is_rules: agree_rules,
        });

        this.closeRegisterFinishPopup();
        // После регистрации не логиним автоматически — показываем стандартный попап.
        this.openRegisterPopupSuccess();
        this.formSending = false;
      } catch (error) {
        this.formSending = false;
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          this.responseError = formatApiErrorResponseMessage(
            errorData,
            'Произошла ошибка при регистрации'
          );
          if (errorData && typeof errorData === 'object' && !Array.isArray(errorData)) {
            const skip = new Set(['detail', 'message', 'non_field_errors']);
            Object.keys(errorData).forEach((field) => {
              if (skip.has(field) || this.errors[field]) return;
              const v = errorData[field];
              this.errors[field] = Array.isArray(v) ? v.join(', ') : v;
            });
          }
        } else {
          this.responseError = 'Произошла ошибка при регистрации. Попробуйте позже.';
        }
      }
    },
    switchToLogin() {
      this.addBodyClass();
      this.showResetPasswordSuccess = false;
      this.showLoginPopup = true;
      this.showRegisterPopup = false;
      this.responseError = '';
    }
  },
  beforeUnmount() {
    // Очищаем таймер при разрушении компонента
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
    this.stopCheckingForNewChecks();
    window.removeEventListener('resize', this.applyPerformanceMode);
    if (this._handleScrollRafId) {
      cancelAnimationFrame(this._handleScrollRafId);
      this._handleScrollRafId = null;
    }
    document.removeEventListener('click', this.handleDynamicButtonClick);
  },
};
</script>


<style lang="scss">
  @import '@/assets/scss/App.scss';
</style>
